// NPM Imports
import React, { Component } from "react";
import Modal from "react-responsive-modal";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Toastr } from "@revvsales/components";

// Actions Imports
import { deleteSnapLinkAction } from "../../actions/DocumentActions";

class PermaDisablePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showButtunLoader: false,
    };
  }

  _toggleLoader = (type, flag) => {
    this.setState({ [type]: flag });
  };

  _closePopup = () => {
    this.props.toggleModalPopUp("snapLinkOffPopup", false);
  };

  _submit = () => {
    this._toggleLoader("showButtunLoader", true);
    this.props
      .deleteSnapLinkAction(this.props.docObjectId, "DOC")
      .then(() => {
        Toastr.showToastr({
          type: "success",
          message: "Snap link switched off and deleted",
          timeout: 3000,
        });
        this._toggleLoader("showButtunLoader", false);
        this.props.updateMultipleState({
          snapLinkOffPopup: false,
          showAcceptAndSignBtnLoader: false,
        });
      })
      .catch(error => {
        console.error(
          `QuotationTopBarV2 => _disableSnapLink => Error : ${error}`,
        );
        Toastr.showToastr({
          type: "failure",
          message: "Oops! Something went wrong. Please try again later.",
          timeout: 3000,
        });
        this.props.updateMultipleState({
          SnapLinkOffPopup: false,
          showAcceptAndSignBtnLoader: false,
        });
      });
  };

  render() {
    const { showButtunLoader } = this.state;
    return (
      <Modal open onClose={this._closePopup} center closeOnOverlayClick={false}>
        <div className="docrecipientspopup-container">
          {/* ----------- Modal Heading Section ----------- */}
          <div className="modal-heading" data-test="emptysigner-modal-heading">
            <FontAwesomeIcon
              className="emptysigner-popup-exclamation-icon"
              icon={["fas", "exclamation-triangle"]}
            />{" "}
            You are about to switch off snap link
          </div>

          <div className="permalink-popup-content-section">
            If you switch off snap link, the existing link will expire. Anyone
            you have shared the link with will not be able to access the
            document anymore.
          </div>

          <div className="permalink-popup-content-section">
            You can switch it on at anytime to get a new snap link for this
            document and reshare it with anyone.
          </div>

          {/* ----------- Modal Footer Section ----------- */}
          <div className="modal-footer">
            <Button
              className="btn-transparent"
              onClick={this._closePopup}
              data-test="snapdisablepopup-cancel-btn">
              Cancel
            </Button>
            <Button
              id="emapty-signer-back-btn"
              className="btn btn-primary modal-footer-btn submit-btn"
              data-test="emptysigner-back-btn"
              isLoading={showButtunLoader}
              onClick={this._submit}>
              Switch off snap link
            </Button>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  deleteSnapLinkAction,
};

export default connect(
  null,
  mapDispatchToProps,
)(PermaDisablePopup);



// WEBPACK FOOTER //
// ./src/components/DocumentApprovalPopupNew/SnapDisablePopup.js